import { Helmet } from 'react-helmet-async';
import { companyInfo } from '../data/mock';

const SchemaMarkup = ({ type = 'Organization', pageData = {} }) => {
  // Organization Schema
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": companyInfo.name,
    "alternateName": companyInfo.shortName,
    "url": "https://cngtpl.in",
    "logo": "https://customer-assets.emergentagent.com/job_cosmos-digital-suite/artifacts/i2mcz56n_CNGTPL%20FINAL.png",
    "description": companyInfo.tagline,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "26, Gurunanakpura Road",
      "addressLocality": "Laxmi Nagar",
      "addressRegion": "New Delhi",
      "postalCode": "110092",
      "addressCountry": "IN"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": companyInfo.phone,
      "contactType": "Customer Service",
      "areaServed": "IN",
      "availableLanguage": ["en", "hi"]
    },
    "sameAs": [
      "https://www.facebook.com/cngtpl",
      "https://www.linkedin.com/company/cngtpl",
      "https://twitter.com/cngtpl"
    ],
    "foundingDate": "2018",
    "numberOfEmployees": {
      "@type": "QuantitativeValue",
      "value": "50"
    }
  };

  // Local Business Schema
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": companyInfo.name,
    "image": "https://customer-assets.emergentagent.com/job_cosmos-digital-suite/artifacts/i2mcz56n_CNGTPL%20FINAL.png",
    "@id": "https://cngtpl.in",
    "url": "https://cngtpl.in",
    "telephone": companyInfo.phone,
    "priceRange": "$$",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "26, Gurunanakpura Road",
      "addressLocality": "Laxmi Nagar",
      "addressRegion": "Delhi",
      "postalCode": "110092",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 28.6362,
      "longitude": 77.2765
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "opens": "09:00",
      "closes": "18:00"
    }
  };

  // Service Schema
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Technology & Workforce Solutions",
    "provider": {
      "@type": "Organization",
      "name": companyInfo.name
    },
    "areaServed": {
      "@type": "Country",
      "name": "India"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Technology Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Software & AI Development"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "ERP Solutions"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Cyber Security Services"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Manpower Services"
          }
        }
      ]
    }
  };

  // Breadcrumb Schema
  const breadcrumbSchema = pageData.breadcrumbs ? {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": pageData.breadcrumbs.map((crumb, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": crumb.name,
      "item": `https://cngtpl.in${crumb.path}`
    }))
  } : null;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(serviceSchema)}
      </script>
      {breadcrumbSchema && (
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      )}
    </Helmet>
  );
};

export default SchemaMarkup;
